import { Component, OnInit } from '@angular/core';
import { MfaService } from '../../services/mfa.service';
import { select, Store } from '@ngrx/store';
import { MfaInterface } from '../../models/mfa.interface';
import { ConstsHelper } from '../../../../helpers/consts.helper';
import { MfaInterfaceState } from '../../store/state/mfa.state';
import { MsisdnListInterfaceState } from '../../../lines/store/state/msisdn-list.state';
import { GetMsisdnList } from '../../../lines/store/actions/msidn-list.actions';
import moment from 'moment';
import { CustomerStorageService } from '../../../account/services/customer-storage.service';
import { CryptService } from '../../services/crypt.service';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-mfa-popup',
  templateUrl: './mfa-popup.component.html',
  styleUrls: ['./mfa-popup.component.css'],
  standalone: false
})
export class MfaPopupComponent implements OnInit {

  mfa: MfaInterface|null;
  phoneNumbers: Array<string> = [];
  selectedPhoneNumber: string;
  lastGeneratedCodeDate: number;
  displayResendCodeButton: boolean;
  environment = environment;

  constructor(
      private mfaService: MfaService,
      private customerStorageService: CustomerStorageService,
      private store: Store<any>,
      private cryptService: CryptService
  ) {}

  ngOnInit() {
    this.mfa = null;
    this.lastGeneratedCodeDate = null;
    this.selectedPhoneNumber = null;
    this.displayResendCodeButton = false;
    this.store.pipe(select(ConstsHelper.REDUCER_MFA)).subscribe((response: MfaInterfaceState) => {
      if (response.result != null) {
        this.mfa = response.result;
        this.store.dispatch(new GetMsisdnList());
      }
    });
    this.store.pipe(select(ConstsHelper.REDUCER_MSISDN_LIST)).subscribe((response: MsisdnListInterfaceState) => {
      this.phoneNumbers = [];
      this.selectedPhoneNumber = null;
      if (response.list instanceof Array && response.list.length > 0) {
        for (let i = 0; i < response.list.length; i++) {
          if ('active' === response.list[i].status.toLowerCase() && response.list[i].phoneNumber.length == 10) {
            this.phoneNumbers.push(response.list[i].phoneNumber);
          }
          if (i === (response.list.length - 1)) {
            this.updateData();
          }
        }
      }
    });
    setInterval(function() {
      if (this.lastGeneratedCodeDate && this.lastGeneratedCodeDate <= parseInt(moment(new Date()).format('YYYYMMDDHHmmss'), 10)) {
        this.displayResendCodeButton = true;
      }
    }.bind(this), 1000);
  }

  close() {
    this.mfa.visibility = false;
  }

  setSelectedPhoneNumber(event) {
    this.selectedPhoneNumber = null;
    if (event.target.value.length === 10) {
      this.selectedPhoneNumber = event.target.value;
    }
  }

  sendCode() {
    if (this.selectedPhoneNumber === null && this.mfa.destination === null) {
      this.mfa.errorMessage = 'Ce champ est obligatoire, merci de choisir un numéro dans la liste ci-dessus.';
    } else {
      this.mfa.errorMessage = null;
      const destination = (this.selectedPhoneNumber === null) ? this.mfa.destination : this.selectedPhoneNumber;
      this.mfaService.sendCode(destination, this.mfa.action).subscribe(
          response => {
            this.mfa.step = 2;
            this.mfa.destination = destination;
            this.lastGeneratedCodeDate = parseInt(moment(new Date()).add(1, 'minute').format('YYYYMMDDHHmmss'), 10);
            this.displayResendCodeButton = false;
          }, error => {
            if (error.error.error_message.includes('blocked')) {
              this.mfa.errorMessage = ConstsHelper.ERROR_MESSAGE_MFA_BLOCKED;
            } else {
              this.mfa.errorMessage = ConstsHelper.ERROR_OCCURRED_MESSAGE;
            }
          }
      );
    }
  }

  validate() {
    this.mfa.errorMessage = null;
    if ([undefined, null, ''].indexOf(this.mfa.code) !== -1) {
      this.mfa.errorMessage = 'Ce champ est obligatoire.';
    } else {
      if (this.mfa.destination && this.mfa.action && this.mfa.code) {
        this.mfaService.checkCode(this.mfa.destination, this.mfa.action, this.mfa.code).subscribe(
            response => {
              if ([ConstsHelper.PROCEDURE_ORDER_SIM_CARD, ConstsHelper.PROCEDURE_LOSS_STEAL].indexOf(this.mfa.action) !== -1) {
                this.store.dispatch(new this.mfa.effect(this.mfa.effectData, this.mfa.action, this.mfa));
              } else {
                this.store.dispatch(new this.mfa.effect(this.mfa.effectData, this.mfa));
              }
              localStorage.removeItem(ConstsHelper.LOCAL_STORAGE_UPDATE_SHIPPING_ADDRESS_LOST_STEAL_PROCEDURE);
            }, error => {
              if (this.mfa && error.error.error_message && error.error.error_message.includes('invalid_code')) {
                this.mfa.errorMessage = ConstsHelper.ERROR_MESSAGE_MFA_INVALID_CODE;
              } else if (this.mfa && error.error.error_message && error.error.error_message.includes('blocked')) {
                this.mfa.errorMessage = ConstsHelper.ERROR_MESSAGE_MFA_BLOCKED;
              } else {
                this.mfa.errorMessage = ConstsHelper.ERROR_OCCURRED_RETRY_MESSAGE;
              }
            }
        );
      } else {
        this.mfa = null;
      }
    }
  }

  isEmailDestination() {
    return ConstsHelper.emailPattern.test(this.mfa.destination);
  }

  private updateData() {
    let obj = null;
    if (
        this.mfa &&
        this.mfa.action === 'change_shipping_address' &&
        localStorage.getItem(ConstsHelper.LOCAL_STORAGE_UPDATE_SHIPPING_ADDRESS_LOST_STEAL_PROCEDURE)
    ) {
      obj = JSON.parse(
          this.cryptService.decrypt(
              localStorage.getItem(ConstsHelper.LOCAL_STORAGE_UPDATE_SHIPPING_ADDRESS_LOST_STEAL_PROCEDURE)
          )
      );
    }
    if (
        this.phoneNumbers.length === 1 &&
        this.mfa &&
        this.mfa.action === 'change_shipping_address' &&
        obj !== null &&
        obj.secretValue === ConstsHelper.UPDATE_SHIPPING_ADDRESS_LOST_STEAL_PROCEDURE_VALUE &&
        obj.msisdn === this.phoneNumbers[0]
    ) {
      this.mfa.destination = this.customerStorageService.getCustomer().email;
    } else if (this.mfa && ['order_sim_card', 'loss_steal'].indexOf(this.mfa.action) === -1) {
      this.mfa.destination = null;
      if (this.phoneNumbers.length > 0) {
        if (this.mfa.step === 1 && this.phoneNumbers.length === 1) {
          this.mfa.destination = this.phoneNumbers[0];
        } else if (this.mfa.step === 1 && this.phoneNumbers.length === 0) {
          this.mfa.destination = this.customerStorageService.getCustomer().email;
        }
      } else if (this.phoneNumbers.length === 0) {
        this.mfa.destination = this.customerStorageService.getCustomer().email;
      }
    }
  }
}
